import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-base-header',
  templateUrl: './base-header.component.html',
  standalone: false,
  styleUrls: ['./base-header.component.scss'],
})
export class BaseHeaderComponent {
  @Input() userSubTitle: string;
}
